import { render, staticRenderFns } from "./coupon-card.vue?vue&type=template&id=54e98392&"
import script from "./coupon-card.vue?vue&type=script&lang=js&"
export * from "./coupon-card.vue?vue&type=script&lang=js&"
import style0 from "./coupon-card.vue?vue&type=style&index=0&id=54e98392&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports